"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReEnrichButton = void 0;
const react_1 = __importDefault(require("react"));
const re_enrich_button_styles_1 = require("./re-enrich-button.styles");
const icons_1 = require("../../../../../icons");
const ReEnrichButton = (_a) => {
    var { loading, disabled, children } = _a, props = __rest(_a, ["loading", "disabled", "children"]);
    return (react_1.default.createElement(re_enrich_button_styles_1.StyledReEnrichButton, Object.assign({ rounded: true, color: "primary", variant: "text", disabled: disabled || loading, endIcon: react_1.default.createElement(icons_1.ReloadIcon, null), "$loading": loading }, props), children));
};
exports.ReEnrichButton = ReEnrichButton;
exports.default = exports.ReEnrichButton;
